import { isEn } from "project-config/utils/env";

export const enI18n = {
  overview_platform_notice: "Platform notice",
};
export const zhI18n = {
  overview_platform_notice: "平台公告",
};

export const getTranslateNsT = (local: "zh" | "en" = isEn() ? "en" : "zh") => {
  return (key: string) =>
    ({
      zh: zhI18n,
      en: enI18n,
    }[local][key] || "");
};
